module.exports = __webpack_public_path__ + "media/images/bg_reviews-cb81c162d6e7ddcc897fa61faef567d6.jpg";